(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.kabAuthorTabs = {
    attach: (context) => {

      const $buttons = $('.blog-author--view-mode-full__buttons button', context);
      if (!$buttons.length) {
        return;
      }

      // Buttons.
      const $post_button = $('#posts', context);
      const $recipes_button = $('#recipes', context);
      
      // Tabs.
      const $posts_tab = $('#blog-author--view-mode-full__posts', context);
      const $recipes_tab = $('#blog-author--view-mode-full__recipes', context);
      const $tabs = $('.blog-author--view-mode-full__section', context);

      $(once('buttons', $buttons)).each(function () {
        let $button = $(this);
        $button.click(function(e) {
          removeTabClasses();
          makeActive($button);
          switch(this.id) {
            case 'posts':
              $posts_tab.addClass('active-tab');
              break;
            case 'recipes':
              $recipes_tab.addClass('active-tab')
              break;
            default:
              return;
          }
        })

        $button.keyup(function(e) {
          let $keycode = e.keyCode;
          if ($keycode == 9) { // tab key.
            $($button.click());
          }
          if ($keycode == 37 || $keycode == 39) { // left and right arrow keys.
            switch(this.id) {
              case 'posts':
                $recipes_button.focus().click().attr('tabindex', '0');
                $post_button.attr('tabindex', '-1');
                break;
              case 'recipes':
                $post_button.focus().click().attr('tabindex', '0');;
                $recipes_button.attr('tabindex', '-1');
                break;
              default:
                return;
            }
          } 
        });

      });

      function makeActive(button) {
        button.addClass('active-button');
        button.attr('aria-selected', true);
      }

      function removeTabClasses() {
        $tabs.removeClass('active-tab');
        $buttons.removeClass('active-button');
        $buttons.attr('aria-selected', false);
      }

    }
  };
})(jQuery, Drupal);
